import ContentOptions from "../../../../../models/state/contents/content/options/ContentOptions";

export function isSequential(options: ContentOptions): boolean {
  return options.sequential;
}

export function isExercise(options: ContentOptions): boolean {
  return options.exercise;
}
